import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import { Col, Row } from 'antd'
import React from 'react'
import styled from 'styled-components'
const LeftCol = styled(Col)`
  padding-left: 20px;
`
const CenterCol = styled(Col)`
  text-align: center;
`

const RightArrow = styled(RightOutlined)`
  cursor: pointer;
`

const LeftArrow = styled(LeftOutlined)`
  cursor: pointer;
`

const CalendarPaper = ({ value, onChange }) => {
  const month = value.month()
  const year = value.year()

  return (
    <div>
      <Row
        type="flex"
        justify="space-between"
        style={{ background: '#FAFAFB' }}
      >
        <LeftCol span={4}>
          <LeftArrow
            onClick={() => {
              const newValue = value.clone()
              newValue.month(month - 1)
              onChange(newValue)
            }}
          />
        </LeftCol>
        <CenterCol span={16}>
          <b>
            {' '}
            {value.format('MMMM')} , {year}
          </b>

          <p />
        </CenterCol>

        <Col span={4}>
          <RightArrow
            onClick={() => {
              const newValue = value.clone()
              newValue.month(month + 1)
              onChange(newValue)
            }}
          />
        </Col>
      </Row>
    </div>
  )
}

export default CalendarPaper
